export const ClientBookmarksEmpty = {
    clientBookmarksForClientMain: "お気に入りの登録がありません。",
    clientBookmarksForClientDescription: "注目したプロをお気に入りに登録することができます。",

};



// WEBPACK FOOTER //
// ./src/config/view_const/client_bookmarks.ts